import facebook from 'assets/images/social/Facebook.svg'
import linkenid from 'assets/images/social/Linkedin.svg'
import twiter from 'assets/images/social/Twitter.svg'
import youtube from 'assets/images/social/Youtube.svg'
import React from 'react'
import './footer.css'

const Footer: React.FC = () => {
  return (
    <>
      <pichincha-grid container={true} class="backPrin" justify="space-between">
        <pichincha-grid item={true} md={8} className="colorFoter">
          <pichincha-typography variant="smallText">
            Banco Pichincha 2020. Todos los derechos reservados.
          </pichincha-typography>
        </pichincha-grid>
        <pichincha-grid item={true} md={4} class="t-align-right disabled">
          <a
            className="iconSocial "
            href="https://www.facebook.com/BancoPichinchaEcuador/"
          >
            <img src={facebook} id="facebook" alt="facebook" />
          </a>
          <a className="iconSocial " href=" https://twitter.com/BancoPichincha">
            <img src={twiter} id="twiter" alt="twiter" />
          </a>
          <a
            className="iconSocial "
            href="https://www.linkedin.com/company/banco-pichincha-ca/"
          >
            <img src={linkenid} id="linkenid" alt="linkenid" />
          </a>
          <a
            className="iconSocial "
            href="https://www.youtube.com/user/BancoPichinchaCA"
          >
            <img src={youtube} id="youtube" alt="youtube" />
          </a>
        </pichincha-grid>
      </pichincha-grid>
    </>
  )
}

export default Footer
